import { render, staticRenderFns } from "./TopDrgsTable.vue?vue&type=template&id=74026559&"
import script from "./TopDrgsTable.vue?vue&type=script&lang=js&"
export * from "./TopDrgsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports